import axios from 'axios'
import qs from 'qs'
import {get, post, proxy} from './simpleapi'
import {getLocalStorage} from './../utils/CommonUtil'
import {loginUserKey} from './../utils/Config'
import {getUserInfo} from './../utils/UserUtil'
import {getUserToken} from "../utils/UserUtil";

let formDataHeader = {
  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
let formData2Header = {
  'Content-Type': 'application/form-data; charset=UTF-8'
}
let jsonDataHeader = {
  'Content-Type': 'application/json; charset=UTF-8',
  'token': "" + getUserToken()
}
// url 参数调用测试
export const testUrlGet = (params) => axios.get(proxy + '/test/url/get', {params});
export const testUrlGetAuthServerPuk = (params) => axios.get(proxy + '/security/login/auth_server/puk', {params});

export const loginStatus = (params) => axios.get(proxy + '/security/login/status', {params: params, headers:
    {
      token: getUserToken()
    }});
export const logout = () => axios.post(proxy + '/security/logout/auth_server/token', {}
  ,{headers:
    {
      token: getUserToken()
    }});

export const mallGoodsList = (params) => axios.get(proxy + '/mall/goods/list', {params});

export const mallGoodsDetails = (params) => axios.get(proxy + '/mall/goods/page/details', {params});

export const tesUrlPost = (data) => axios.post(proxy + '/test/url/post', data)

export const tesUrlPostBody = (data) => axios.post(proxy + '/test/url/post_body', data)

export const login = (data) => axios.post(proxy + '/login', qs.stringify(data), {headers: formDataHeader})

export const login2 = (data) => axios.post(proxy + '/login', data, {headers: jsonDataHeader})

export const authServerToken = (data) => axios.post(proxy + '/security/login/auth_server/token', data)

export const oauthToken = (data) => axios.post(proxy + '/oauth/token', data, {headers: formData2Header})

export const articleList = (params) => axios.get(proxy + '/blog/article/list', {params})
export const articleDetails = (params) => axios.get(proxy + '/blog/article/details', {params})



// WEBPACK FOOTER //
// ./src/api/api.js